import React from 'react';

interface Props {
  size: number;
}

const FrenchIcon = (props: Props) => {
  const { size } = props;
  return (

    <svg width={size} height={size} viewBox="0 0 512 512" version="1.1">
      <g id="group">
        <path id="Tracé" d="M232.5 -0.5 L278.5 -0.5 C300.956 1.945 322.956 6.945 344.5 14.5 L344.5 496.5 C322.956 504.055 300.956 509.055 278.5 511.5 263.167 511.5 247.833 511.5 232.5 511.5 209.475 509.161 187.141 503.827 165.5 495.5 166.833 335.5 166.833 175.5 165.5 15.5 187.141 7.173 209.475 1.839 232.5 -0.5 Z" fill="#f0f0f0" fillOpacity="1" stroke="none" />
      </g>
      <g id="group-1">
        <path id="Tracé-1" d="M163.5 16.5 C164.833 95.831 165.5 175.497 165.5 255.5 165.5 335.503 164.833 415.169 163.5 494.5 104.961 472.137 60.461 433.47 30 378.5 13.305 347.029 3.139 313.696 -0.5 278.5 -0.5 263.167 -0.5 247.833 -0.5 232.5 10.387 142.857 54.721 75.357 132.5 30 142.398 24.381 152.732 19.881 163.5 16.5 Z" fill="#0252b4" fillOpacity="1" stroke="none" />
      </g>
      <g id="group-2">
        <path id="Tracé-2" d="M347.5 16.5 C406.039 38.863 450.539 77.53 481 132.5 491.706 152.454 499.539 173.454 504.5 195.5 504.294 198.495 504.96 201.162 506.5 203.5 508.582 213.195 510.249 222.862 511.5 232.5 L511.5 278.5 C500.612 368.144 456.279 435.644 378.5 481 368.602 486.619 358.268 491.119 347.5 494.5 346.167 415.169 345.5 335.503 345.5 255.5 345.5 175.497 346.167 95.831 347.5 16.5 Z" fill="#d80227" fillOpacity="1" stroke="none" />
      </g>
    </svg>

  );
};

export default FrenchIcon;
